import { formatNameInitials } from './formatters'

export function getUserInitials(displayName: string, username: string): string {
  return formatNameInitials(displayName) || formatNameInitials(username).charAt(0) || '?'
}
